import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { UserQuery } from '@state/user';
import { HomeService } from '@app/shared/services/home.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-nav-container',
  styleUrls: ['./nav-container.component.scss'],
  templateUrl: './nav-container.component.html'
})
export class NavContainerComponent implements OnInit {
  @Input() showSecondaryNavButtons = true;

  mobileMenuActive = false;

  constructor(private userQuery: UserQuery, private homeService: HomeService) {}

  ngOnInit(): void {}

  get loggedIn(): boolean {
    return this.userQuery.userExists();
  }

  toggleMobileMenu(): void {
    this.mobileMenuActive = !this.mobileMenuActive;
  }

  onScrollToProducts(): void {
    this.homeService.onScrollToProducts();
  }
}
